import gql from 'graphql-tag'

export const fragment = gql`
	fragment cashRegisterFields on CashRegister {
		id
    name
		shopId
		shop {
			name
		}
	}
`

const query = gql`
query listCashRegisters($deviceType: cashRegisterType) {
	cashAssist {
		listCashRegisters(
			deviceType: $deviceType,
			params: {
				sort: [{ field: "name", order: ASC }]
			}
		) {
	    ...cashRegisterFields
	  }
	}
}
${fragment}`

export default query
